import React from 'react'
import EditMenu from '../../../components/organisms/admin/menu/EditMenu'
import EditQuestion from '../../../components/organisms/admin/question/EditQuestion'

type Props = {}

const EditQuestionPage = (props: Props) => {
  return (
    <EditQuestion />
  )
}

export default EditQuestionPage